import { render, staticRenderFns } from "./PhoneProductCardLoading.vue?vue&type=template&id=6a817746"
import script from "./PhoneProductCardLoading.vue?vue&type=script&lang=ts"
export * from "./PhoneProductCardLoading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports